/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const IndentIncrease = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M21 12H11" }],
    ["path", { d: "M21 18H11" }],
    ["path", { d: "M21 6H11" }],
    ["path", { d: "m3 8 4 4-4 4" }]
  ]
];

export { IndentIncrease as default };
//# sourceMappingURL=indent-increase.js.map
